import { fabric } from 'fabric';
import { CanvasDataTypes } from './canvas-data-types';

/**
 * PRCM-10916: Removes the image (and its associated low-res PhotoIcon) already
 * occupying a photo zone so a new image can replace it in place.
 *
 * Shared by the click-to-fill flow (`addPhotoToPhotozone` in `use-photo.ts`)
 * and the drag-to-canvas drop flow (`onPhotoTrayImageDrop`) so replace-in-place
 * behaves identically for both. Without this, `fillPhotoZone` sends the new
 * image to the back while the previous zone image stays on top — making the
 * replace appear to do nothing and leaking orphaned canvas objects.
 *
 * @param canvas - The fabric canvas holding the photo zone objects
 * @param photozoneId - The id/name of the zone whose current image should be removed
 */
export const removeExistingPhotoZoneImage = (
  canvas: fabric.Canvas | null | undefined,
  photozoneId: string | null | undefined,
): void => {
  if (!canvas || !photozoneId) {
    return;
  }

  const existingImage = canvas
    .getObjects()
    .find((obj) => obj.data?.type === CanvasDataTypes.PhotoZoneImage && obj.data?.photoZoneId === photozoneId);

  if (!existingImage) {
    return;
  }

  const existingIcon = canvas
    .getObjects()
    .find((obj) => obj.data?.type === CanvasDataTypes.PhotoIcon && obj.data?.parentName === existingImage.name);

  if (existingIcon) {
    canvas.remove(existingIcon);
  }

  canvas.remove(existingImage);
};
